// extracted by mini-css-extract-plugin
export default {"container":"LinkLogin_container__DWv3T"};